import { analyticsService } from "@services/analyticsService";
import {
  useWSModalCustom,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";

type Props = {
  onboardingType: "Payee" | "Payer";
} & WSModalCustomProps<void>;

export const ModalExit: React.FC<Props> = ({ onboardingType, ...props }) => {
  const history = useHistory();

  return (
    <WSModal
      title="Exit setup"
      size="S"
      actions={{
        alignment: "fill",
        sortButtons: false,
        buttons: [
          {
            kind: "Secondary",
            label: "Cancel, keep going",
            onClick: () => {
              props.onClose();
            }
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Exit setup",
            onClick: () => {
              analyticsService.track("Onboarding Exited", {
                onboardingType
              });
              history.push("/member/dashboard");
            }
          }
        ]
      }}
      {...props}
    >
      <WSList gap="XL">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to exit your setup flow?
        </WSText.ParagraphSm>

        <WSInfoBox>
          The information on this page is required to setup your Wingspan
          account and activate features, if you exit or leave without completing
          this step, you will require to do this later.
        </WSInfoBox>
      </WSList>
    </WSModal>
  );
};

export const useModalExit = () => useWSModalCustom(ModalExit);
